import { render, staticRenderFns } from "./MATC.vue?vue&type=template&id=d9f19b42"
import script from "./MATC.vue?vue&type=script&lang=js"
export * from "./MATC.vue?vue&type=script&lang=js"
import style0 from "./MATC.vue?vue&type=style&index=0&id=d9f19b42&prod&lang=scss"
import style1 from "./MATC.vue?vue&type=style&index=1&id=d9f19b42&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports